<template>
    <div
      class="modal fade"
      id="kt_modal_split_job"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg p-9">
        <div class="modal-content modal-rounded">
          <div class="modal-header py-7 d-flex justify-content-between">
            <h2 class="m-0">
              Split Job
            </h2>
            <div
              class="btn btn-sm btn-icon btn-active-color-primary"
              data-bs-dismiss="modal"
            >
              <i class="ki-solid ki-cross fs-1 text-dark"></i>
            </div>
          </div>
          <div class="modal-body scroll-y m-5 p-3">
              <p>How many separate jobs do you want to split this job into?</p>
  
              <div class="mb-8">
                  <label for="recurrences" class="form-label">Recurrences</label>
                  <div class="position-relative">
                    <span class="text-danger" v-if="v$.form.recurrences.$error">The number of recurrences must be a positive number</span>
                    <input type="number" v-model="form.recurrences" id="recurrences" class="form-control" />
                  </div>
              </div>
  
              <button class="btn btn-primary me-4" @click="submitForm()" :data-bs-dismiss="!v$.form.$invalid && !v$.form.$error ? 'modal' : ''">Split</button>
              <button class="btn btn-light" data-bs-dismiss="modal" @click="clearForm()">Cancel</button>
  
            </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import useVuelidate from "@vuelidate/core";
  import { required, numeric } from "@vuelidate/validators";
  export default {
    props: ['job'],
    setup: () => ({ v$: useVuelidate() }),
      data() {
          return {
              form: {
                  jobId: '',
                  recurrences: null,
              }
          }
      },
      validations() {
          return {
              form: {
                recurrences: { required, numeric }
              }
          }
      },
      created() {
        this.init();
        },
        methods: {
            init() {
                this.form.jobId = this.job.id;
            },
          checkValidation(){
            this.v$.form.$touch()
            this.v$.$validate();
          },
          async submitForm() {
              await this.v$.$validate();
              this.v$.form.$touch();
              if(!this.v$.$error) {
                this.$api.splitJob(this.form.jobId, this.form.recurrences).then(() => {
                  this.$parent.splitJob();
                });
              }
          },
          clearForm() {
              this.v$.$reset();
              this.form.reccurences = 1;
          },
      }
  };
  </script>